var map = {
	"./btn_file_doc.png": 541,
	"./btn_file_pdf.png": 542,
	"./btn_file_zip.png": 260
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 816;



//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cloud ^\.\/btn_file_.*\.png$
// module id = 816
// module chunks = 3